import type { ButtonLinkField } from '@/src/cms/domain/models/fields/button-link-field';

export class ButtonLinkFieldViewModel {
  uri: string;
  title: string;
  target: HTMLAnchorElement['target'];

  protected constructor(data: ButtonLinkFieldViewModel) {
    this.uri = data.uri;
    this.title = data.title;
    this.target = data.target;
  }

  static presenter(entity: ButtonLinkField): ButtonLinkFieldViewModel {
    return new ButtonLinkFieldViewModel({
      uri: entity.uri,
      title: entity.title,
      target: entity.target
    });
  }
}
